import { userNoAvatar } from '@images';
import { createImageErrorHandler } from '@utils/onImageError';
import type { FC } from 'react';
import { memo } from 'react';
import { twcls } from '@utils/twcls';

interface AvatarProps {
  src: string | null | undefined;
  size?: 'xs' | 'md' | 'xl' | 'lg';
  rounded?: boolean;
  alt?: string;
  className?: string;
}

const onImgError = createImageErrorHandler(userNoAvatar);

const Avatar: FC<AvatarProps> = ({
  src,
  size = 'md',
  alt,
  rounded = true,
  className
}) => {
  const styles = twcls(
    'block overflow-hidden rounded-sm',
    size === 'xs' && 'w-11 h-11',
    size === 'md' && 'w-11 h-11',
    size === 'lg' && 'w-11 h-11',
    size === 'xl' && 'w-11 h-11',
    rounded && 'rounded-full',
    className
  );
  return (
    <div className={styles}>
      <img
        src={src || userNoAvatar}
        className='object-cover w-full h-full'
        alt={alt || 'Аватар'}
        onError={onImgError}
      />
    </div>
  );
};

export default memo(Avatar);
